<template>
  <div class="weekday-interval__wrapper">
    <transition-group name="fade">
      <div
        v-for="(interval, index) in intervals"
        :key="`weekday-interval-${index}`"
        :ref="`weekday-interval-${index}`"
        class="weekday-interval__row"
      >
        <div
          class="weekday-interval__row-wrapper"
          @mouseenter="interval.showRemove = true"
          @mouseleave="interval.showRemove = false"
        >
          <span class="weekday-interval__label">das</span>

          <!-- Starting hour -->
          <div
            v-click-outside="() => interval.start.showHours = false"
            :class="interval.start.showHours && 'weekday-interval__select--active'"
            class="weekday-interval__select weekday-interval__select--hour"
          >
            <div
              :class="interval.start.showHours && 'weekday-interval__pick--open'"
              class="weekday-interval__pick"
              @click="
                interval.start.showHours = !interval.start.showHours;
                scrollToOption(
                  `select-start-hour-list-${index}`,
                  `select-start-hour-list-${index}-item-${interval.start.hours}`,
                  interval.start.showHours
                )
              "
            >
              <span>{{ String(interval.start.hours).padStart(2, '0') }}</span>
              <i class="icon icon-arrow-down" />
            </div>

            <ul
              v-if="interval.start.showHours"
              :id="`select-start-hour-list-${index}`"
              class="weekday-interval__select-list"
            >
              <li
                v-for="i in hours"
                :key="`select-start-hour-item-${i}`"
                :id="`select-start-hour-list-${index}-item-${i}`"
                :class="(i === interval.start.hours) && 'weekday-interval__select-item--selected'"
                class="weekday-interval__select-item"
                @click="
                  interval.start.hours = i;
                  interval.start.showHours = false;
                  watchEndingInterval(interval);
                "
              >
                {{ String(i).padStart(2, '0') }}
              </li>
            </ul>
          </div>

          <span class="weekday-interval__label weekday-interval__label--separator">
            :
          </span>

          <!-- Starting min -->
          <div
            v-click-outside="() => interval.start.showMinutes = false"
            :class="interval.start.showMinutes && 'weekday-interval__select--active'"
            class="weekday-interval__select weekday-interval__select--min"
          >
            <div
              :class="interval.start.showMinutes && 'weekday-interval__pick--open'"
              class="weekday-interval__pick"
              @click="
                interval.start.showMinutes = !interval.start.showMinutes;
                scrollToOption(
                  `select-start-min-list-${index}`,
                  `select-start-min-list-${index}-item-${interval.start.minutes}`,
                  interval.start.showMinutes
                )
              "
            >
              <span>{{ String(interval.start.minutes).padStart(2, '0') }}</span>
              <i class="icon icon-arrow-down" />
            </div>

            <ul
              v-if="interval.start.showMinutes"
              :id="`select-start-min-list-${index}`"
              class="weekday-interval__select-list"
            >
              <li
                v-for="i in minutes"
                :key="`select-start-hour-item-${i}`"
                :id="`select-start-min-list-${index}-item-${i}`"
                :class="(i === interval.start.minutes) && 'weekday-interval__select-item--selected'"
                class="weekday-interval__select-item"
                @click="
                  interval.start.minutes = i;
                  interval.start.showMinutes = false;
                  watchEndingInterval(interval);
                "
              >
                {{ String(i).padStart(2, '0') }}
              </li>
            </ul>
          </div>

          <span class="weekday-interval__label">às</span>

          <!-- Ending hour -->
          <div
            v-click-outside="() => interval.end.showHours = false"
            :class="interval.end.showHours && 'weekday-interval__select--active'"
            class="weekday-interval__select weekday-interval__select--hour"
          >
            <div
              :class="interval.end.showHours && 'weekday-interval__pick--open'"
              class="weekday-interval__pick"
              @click="
                interval.end.showHours = !interval.end.showHours;
                scrollToOption(
                  `select-end-hour-list-${index}`,
                  `select-end-hour-list-${index}-item-${interval.end.hours}`,
                  interval.end.showHours
                )
              "
            >
              <span>{{ String(interval.end.hours).padStart(2, '0') }}</span>
              <i class="icon icon-arrow-down" />
            </div>

            <ul
              v-if="interval.end.showHours"
              :id="`select-end-hour-list-${index}`"
              class="weekday-interval__select-list"
            >
              <li
                v-for="i in hours.slice(interval.start.hours)"
                :key="`select-end-hour-item-${i}`"
                :id="`select-end-hour-list-${index}-item-${i}`"
                :class="(i === interval.end.hours) && 'weekday-interval__select-item--selected'"
                class="weekday-interval__select-item"
                @click="
                  interval.end.hours = i;
                  interval.end.showHours = false;
                  watchEndingInterval(interval);
                "
              >
                {{ String(i).padStart(2, '0') }}
              </li>
            </ul>
          </div>

          <span class="weekday-interval__label weekday-interval__label--separator">
            :
          </span>

          <!-- Ending min -->
          <div
            v-click-outside="() => interval.end.showMinutes = false"
            :class="interval.end.showMinutes && 'weekday-interval__select--active'"
            class="weekday-interval__select weekday-interval__select--min"
          >
            <div
              :class="interval.end.showMinutes && 'weekday-interval__pick--open'"
              class="weekday-interval__pick"
              @click="
                interval.end.showMinutes = !interval.end.showMinutes;
                scrollToOption(
                  `select-end-min-list-${index}`,
                  `select-end-min-list-${index}-item-${interval.end.minutes}`,
                  interval.end.showMinutes
                )
              "
            >
              <span>{{ String(interval.end.minutes).padStart(2, '0') }}</span>
              <i class="icon icon-arrow-down" />
            </div>

            <ul
              v-if="interval.end.showMinutes"
              :id="`select-end-min-list-${index}`"
              class="weekday-interval__select-list"
            >
              <li
                v-for="i in minutes"
                :key="`select-end-hour-item-${i}`"
                :id="`select-end-min-list-${index}-item-${i}`"
                :class="(i === interval.end.minutes) && 'weekday-interval__select-item--selected'"
                class="weekday-interval__select-item"
                @click="
                  interval.end.minutes = i;
                  interval.end.showMinutes = false;
                  watchEndingInterval(interval);
                "
              >
                {{ String(i).padStart(2, '0') }}
              </li>
            </ul>
          </div>

          <transition name="fade">
            <div
              v-show="interval.showRemove && intervals.length > 1"
              class="weekday-interval__row-remove"
              @click="removeInterval(index)"
            >
              <i class="icon icon-cross" />
            </div>
          </transition>
        </div>

        <div
          v-show="index === intervals.length - 1"
          class="weekday-interval__row-add"
          @click="addInterval()"
        >
          <i class="icon icon-plus" />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
Array.range = (from, to, step) => Array.from(
  { length: ~~((to - from) / step) + 1 },
  (v, k) => from + k * step
)

export default {
  name: 'officeWeekdayInterval',

  props: {
    duration: {
      type: Number, // in minutes
      required: true,
      default: () => 30
    },

    initialIntervals: {
      type: Array,
      required: false,
      default: () => [],
      validator: (arr) => {
        if (arr) {
          return arr.some((obj) => {
            if (
              'start' in obj &&
              'hour' in obj.start &&
              'minute' in obj.start &&
              'end' in obj &&
              'hour' in obj.end &&
              'minute' in obj.end &&
              obj.start.hour <= obj.end.hour
            ) {
              return true
            }

            return false
          })
        }

        return true
      }
    }
  },

  data () {
    return {
      hours: [...Array.range(0, 23, 1)],
      minutes: [...Array.range(0, 59, 5)],
      intervals: []
    }
  },

  computed: {
    mergedIntervals () {
      if (this.intervals.length > 0) {
        const mergedIntervals = []
        const intervals = this.intervals.map((i) => {
          return {
            periodStart: `${
              String(i.start.hours).padStart(2, '0')
            }:${
              String(i.start.minutes).padStart(2, '0')
            }`,
            periodStop: `${
              String(i.end.hours).padStart(2, '0')
            }:${
              String(i.end.minutes).padStart(2, '0')
            }`
          }
        })

        intervals.sort((a, b) => parseInt(a.periodStart.replace(':', '')) - parseInt(b.periodStart.replace(':', '')))
        mergedIntervals[0] = intervals[0]

        for (let i = 1; i < intervals.length; i++) {
          const firstIntervalStop = this.$moment.utc(mergedIntervals[0].periodStop, 'HH:mm')
          const currentIntervalStart = this.$moment.utc(intervals[i].periodStart, 'HH:mm')
          const currentIntervalStop = this.$moment.utc(intervals[i].periodStop, 'HH:mm')

          if (
            currentIntervalStart.isSameOrBefore(firstIntervalStop) &&
            currentIntervalStop.isSameOrAfter(firstIntervalStop)
          ) {
            mergedIntervals[0].periodStop = intervals[i].periodStop
          }

          if (currentIntervalStart.isAfter(firstIntervalStop)) {
            mergedIntervals.unshift(intervals[i])
          }
        }

        return mergedIntervals
          .sort((a, b) => parseInt(a.periodStart.replace(':', '')) - parseInt(b.periodStart.replace(':', '')))
      }

      return []
    }
  },

  watch: {
    mergedIntervals: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        this.$emit('set-intervals', this.mergedIntervals)
      }
    }

    // initialIntervals: {
    //   deep: true,
    //   immediate: false,
    //   handler () {
    //     this.init()
    //   }
    // }
  },

  created () {
    this.init()
  },

  mounted () {
    this.$emit('set-intervals', this.mergedIntervals)
  },

  methods: {
    init () {
      if (this.initialIntervals.length) {
        this.initialIntervals.forEach((interval) => {
          const intervalObj = this.buildIntervalObject(
            interval.start.hour,
            interval.start.minute,
            interval.end.hour,
            interval.end.minute
          )

          this.intervals.push(intervalObj)
        })
      } else {
        this.intervals = [
          { ...this.buildIntervalObject(8, 0, 12, 0) },
          { ...this.buildIntervalObject(13, 0, 18, 0) }
        ]
      }
    },

    setValidInterval (interval) {
      const startHourString = `${String(interval.start.hours).padStart(2, 0)}:${String(interval.start.minutes).padStart(2, 0)}`
      const startHourMoment = this.$moment.utc(startHourString, 'HH:mm')
      const finalHourMoment = this.$moment(startHourMoment).add(this.duration, 'minutes')

      interval.end.hours = finalHourMoment.get('hour')
      interval.end.minutes = finalHourMoment.get('minute')
    },

    isValidInterval (interval) {
      const intervalMinutes = this.convertIntervalToMinutes(
        `${String(interval.start.hours).padStart(2, 0)}:${String(interval.start.minutes).padStart(2, 0)}`,
        `${String(interval.end.hours).padStart(2, 0)}:${String(interval.end.minutes).padStart(2, 0)}`
      )

      return this.duration < intervalMinutes
    },

    watchEndingInterval (interval) {
      if (!this.isValidInterval(interval)) {
        this.setValidInterval(interval)
      }
    },

    addInterval () {
      this.intervals.push(this.buildIntervalObject(13, 0, 21, 0))
    },

    removeInterval (index) {
      this.intervals.splice(index, 1)
    },

    convertIntervalToMinutes (start = null, end = null) {
      if (start && end) {
        const intervalStart = this.$moment.utc(start, 'HH:mm')
        const intervalEnd = this.$moment.utc(end, 'HH:mm')
        const intervalMinutes = intervalEnd.diff(intervalStart, 'minutes')

        return intervalMinutes
      }

      return 0
    },

    scrollToOption (where, to, isOpen = false) {
      if (isOpen) {
        this.$nextTick(() => {
          const list = document.querySelector(`#${where}`)
          const item = document.querySelector(`#${to}`)

          list.scrollTop = item.offsetTop
        })
      }
    },

    buildIntervalObject (startHour, startMin, endHour, endMin) {
      return {
        start: {
          hours: startHour,
          showHours: false,
          minutes: startMin,
          showMinutes: false
        },
        end: {
          hours: endHour,
          showHours: false,
          minutes: endMin,
          showMinutes: false
        },
        mergedIntervals: [],
        showRemove: false
      }
    }
  }
}
</script>
